import React from 'react'
import Head from 'next/head'

interface CanonicalLinkProps {
  canonicalUrl: string
}

const CanonicalLink: React.FC<CanonicalLinkProps> = ({ canonicalUrl }) => (
  <Head>
    <link rel="canonical" href={canonicalUrl} key="canonical" />
  </Head>
)

export default CanonicalLink
